export default function InputFieldPerCotton({ setter, item, value }){
    return (
      <div class="row" style={{ marginTop: "5px", marginBottom: "5px" }}>
        <div class="col">
          <input
            type="text"
            value={value}
            class="form-control"
            placeholder="First name"
            style={{ border: "2px solid black", fontWeight: "bold" }}
          />
        </div>
        <div class="col">
          <input
            type="number"
            class="form-control"
            min={0}
            placeholder="Minimum (40 kg)"
            onChange={(event) => {
              setter({ ...item, minimum: event.target.value });
            }}
          />
        </div>
        <div class="col">
          <input
            type="number"
            class="form-control"
            min={0}
            placeholder="Maximum (40 kg)"
            onChange={(event) => {
              setter({ ...item, maximum: event.target.value });
            }}
          />
        </div>
        <div class="col">
          <input
            type="number"
            class="form-control"
            min={0}
            placeholder="Bags"
            onChange={(e) => setter({ ...item, arrivals: e.target.value })}
          />
        </div>
  
        <div class="col">
          <input
            type="number"
            class="form-control"
            min={0}
            placeholder="Unit in kg"
            onChange={(e) => setter({ ...item, arrivalsUnit: e.target.value })}
          />
        </div>
      </div>
    );
  };
